import { render, staticRenderFns } from "./GenericComplaint.vue?vue&type=template&id=23ec1380&scoped=true&"
import script from "./GenericComplaint.vue?vue&type=script&lang=js&"
export * from "./GenericComplaint.vue?vue&type=script&lang=js&"
import style0 from "./GenericComplaint.vue?vue&type=style&index=0&id=23ec1380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ec1380",
  null
  
)

export default component.exports